// extracted by mini-css-extract-plugin
module.exports = {"menu_text":"HeaderMenuSection_menu_text__epTor","activeMenuItem":"HeaderMenuSection_activeMenuItem__bHSoV","header_menu_button":"HeaderMenuSection_header_menu_button__i74C8"};